import { TemplateRef } from '@angular/core';
import { TableAlignEnum } from './table-align.enum';

export interface DocumentsCellContext {
  row: any;
  value: any;
  column: DocumentsTableColumnModel;
}

export interface DocumentsTableColumnModel {
  name: string;
  prop: string;
  width?: string; // '40px' | '1fr'
  minWidth?: string; // '40px'
  sortable?: boolean;
  sortDirection?: 'ASC'|'DESC';
  sortProp?: string; // API sort field, if it differs from `prop`
  sortFn?: Function;
  cell?: string; // key of a projected <ng-template rnplCol="..."> for custom rendering
  template?: TemplateRef<DocumentsCellContext>;
  hidden?: boolean;
  alignment?: TableAlignEnum;
  customizable?: boolean;
  hiddenByDefault?: boolean;
  showWithStatuses?: string[];
  showCondition?: boolean;
  sticky?: 'right';
}

export function getDocumentsTableColumnsGrid(columns: DocumentsTableColumnModel[], selectable: boolean): string {
  const visibleColumns = columns.filter(col => !col.hidden);
  const fillerIndex = getDocumentsTableFillerIndex(visibleColumns);

  const columnsGrid = visibleColumns
    .reduce((acc, col, index) => {
      const width = col.minWidth
        ? `minmax(${col.minWidth}, ${col.width})`
        : col.width;
      const track = index === fillerIndex ? `1fr ${width}` : width;

      return acc ? `${acc} ${track}` : track;
    }, '');

  return selectable ? `40px ${columnsGrid}` : columnsGrid;
}

export function getDocumentsTableFillerIndex(visibleColumns: DocumentsTableColumnModel[]): number {
  const hasFlexibleColumn = visibleColumns.some(col => (col.width || '').includes('fr'));
  if (hasFlexibleColumn) { return -1; }

  let fillerIndex = -1;
  for (let index = visibleColumns.length - 1; index > 0 && visibleColumns[index].sticky === 'right'; index--) {
    fillerIndex = index;
  }
  return fillerIndex;
}
